import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ConfigComponent } from './widgets/config/config.component';
import { SimulatorComponent } from './widgets/simulator/simulator.component';
import { RouteGuard } from './route.guard';
const routes: Routes = [
    { path: 'setup',component: ConfigComponent},
    { path: 'simulator',component: SimulatorComponent, canActivate: [RouteGuard]},
    { path: '',redirectTo: 'setup',pathMatch: 'full'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes,{useHash: true, enableTracing: false,scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
